// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"0698a58881036bd0","node_modules_dompurify_dist_purify_es_mjs":"ca61095ba2129822","node_modules_canvg_lib_index_es_js":"a4a2133b04b17090"}[chunkId] + ".js";
};